import { apiClient } from '../../../utilities/apiClient';

// Cursor cache keyed by page index so the consumer can keep using
// monotonically-increasing page numbers (same shape as the Users page).
// Module-level — clear via clearCursorCache() in the consumer's unmount
// effect so a Users → Posts → Users round-trip doesn't serve stale rows.
const cursorByPage = new Map();
export const clearCursorCache = () => cursorByPage.clear();

export const fetchAnonymousUsers = async ({ page, docLimit }) => {
  const cursor = page === 0 ? null : cursorByPage.get(page - 1) ?? null;
  const res = await apiClient.get('/admin/users/anonymous', {
    params: { limit: docLimit, ...(cursor ? { cursor } : {}) },
  });
  const items = res.data.items ?? [];
  if (res.data.nextCursor) cursorByPage.set(page, res.data.nextCursor);
  return items;
};

export const blockAnonymousUser = ({ userId }) =>
  apiClient.patch(`/admin/users/${userId}`, { isBlocked: true });

export const unblockAnonymousUser = ({ userId }) =>
  apiClient.patch(`/admin/users/${userId}`, { isBlocked: false, isDeactivated: false });

export const deactivateAnonymousUser = ({ userId }) =>
  apiClient.patch(`/admin/users/${userId}`, { isDeactivated: true });

export const getCountOfAnonymousUsers = async () => {
  const res = await apiClient.get('/admin/users/anonymous/count');
  return res.data.count ?? 0;
};
